export default __webpack_public_path__ + "static/media/AL.2fd698f1.svg";